import axios from "axios";
const backendURL = "https://willsguru.com.au/willsguru2024/public";
// const backendURL = "http://localhost/beyond/public";
// // const backendURL = "https://847b-2402-a00-192-7fd6-d99a-d9f3-c004-90d8.ngrok-free.app/";

export const GetProfile = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/profile`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetPersonalDetails = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/get-personal-details`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetPartner = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/get-partner`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetChild = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/get-child`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetSingleChild = (child_id) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));

  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/edit-child`, {
        params: {
          child_id: child_id,
        },
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetSinglePet = (pet_id) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));

  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/get-pet`, {
        params: {
          pet_id: pet_id,
        },
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const GetAllPet = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/all-pets`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetExecutor = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/executor-list`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetAssets = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/asset-list`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetCharity = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/charities`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
// export const FindCharity = (searchInput, charitiesIds) => {
//   const token = JSON.parse(localStorage.getItem("willguru-token"));
//   // Build query string with searchInput and charitiesIds
//   let query = `search_input=${searchInput}`;

//   if (charitiesIds && charitiesIds.length > 0) {
//     charitiesIds.forEach((id, index) => {
//       query += `&charities_ids[${index}]=${id}`;
//     });
//   }
//   return new Promise((resolve, reject) => {
//     axios
//       .get(`${backendURL}/api/auth/find-charity?${query}`, {
//         headers: {
//           Authorization: `Bearer ${token?.access_token}`,
//         },
//       })
//       .then((response) => {
//         // Resolve the promise with the response data
//         resolve(response.data);
//       })
//       .catch((error) => {
//         // Reject the promise with the error
//         reject(error);
//       });
//   });
// };
export const FindCharity = (searchInput, charitiesIds, type) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  // Build query string with searchInput, charitiesIds, and type
  let query = `search_input=${searchInput}`;

  if (charitiesIds && charitiesIds.length > 0) {
    charitiesIds.forEach((id, index) => {
      query += `&charities_ids[${index}]=${id}`;
    });
  }

  if (type) {
    query += `&type=${type}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/find-charity?${query}`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const DivideData = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/get-estate-divide-data`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const RemoveAssets = (assets_id) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/remove-asset?asset_id=${assets_id}`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetDahsboard = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/dashboard`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetGuadinaSetList = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/guardian-set-list`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetAllBeneficiary = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/all-beneficiaries`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetGuardianList = (id, type) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${backendURL}/api/auth/guardian-list?child_or_pet=${type}&child_or_pet_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token?.access_token}`,
          },
        }
      )
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetPackegeList = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/package-list`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const AddCharty = (ids) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/add-charity?${ids}`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const CheckOutApi = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/stripe-checkout?${data}`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
// export const CharitySomeOne = () => {
export const EstateBeneficiarySetList = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/estate-beneficiary-set-list`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetGift = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/get-beneficiaries-for-gifts`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const DocumentData = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/documents`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetRelationship = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/get-relationship`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const GetAssetTypeList = (data) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/asset-type-list`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const RemoveBeneficiryGift = (beneficiars_gifts_id_id) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${backendURL}/api/auth/remove-beneficiary-gift?beneficiars_gifts_id=${beneficiars_gifts_id_id}`,
        {
          headers: {
            Authorization: `Bearer ${token?.access_token}`,
          },
        }
      )
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const RemoveCharityGift = (charity_gifts_id) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${backendURL}/api/auth/remove-charity-gift?charity_gifts_id=${charity_gifts_id}`,
        {
          headers: {
            Authorization: `Bearer ${token?.access_token}`,
          },
        }
      )
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const ResubmitWill = (will_id, note_id) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  const params = new URLSearchParams();
  params.append("will_id", will_id);
  if (note_id !== null) {
    params.append("note_id", note_id);
  }
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${backendURL}/api/auth/resubmit-will?${params.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token?.access_token}`,
          },
        }
      )
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const BeneficiaryListForInvitation = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/invite-beneficiary-list`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};

export const GetSendInvitaion = ($email) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${backendURL}/api/auth/send-invitation-to-beneficiry?email=${$email}`,
        {
          headers: {
            Authorization: `Bearer ${token?.access_token}`,
          },
        }
      )
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const OrderHistoryData = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/order-history`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const OrderDetailsApi = (order_id) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/order-details?order_id=${order_id}`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const CancelSubscription = (subscription_stripe_id) => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${backendURL}/api/auth/subscription-cancel?subscription_stripe_id=${subscription_stripe_id}`,
        {
          headers: {
            Authorization: `Bearer ${token?.access_token}`,
          },
        }
      )
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const GetOffer = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/offer`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const WillErrors = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/errors`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};
export const UpdateWill = () => {
  const token = JSON.parse(localStorage.getItem("willguru-token"));
  return new Promise((resolve, reject) => {
    axios
      .get(`${backendURL}/api/auth/update-will`, {
        headers: {
          Authorization: `Bearer ${token?.access_token}`,
        },
      })
      .then((response) => {
        // Resolve the promise with the response data
        resolve(response.data);
      })
      .catch((error) => {
        // Reject the promise with the error
        reject(error);
      });
  });
};